
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.463 13.243c0-1.545.28-3.06.837-4.548.557-1.487 1.198-2.689 1.923-3.604a17.103 17.103 0 012.341-2.574c.892-.8 1.561-1.344 2.007-1.63.446-.286.753-.486.92-.6l2.258 2.402c-.334.286-.752.715-1.254 1.287-.614.743-1.227 1.687-1.84 2.831-.78 1.316-1.115 2.489-1.003 3.518 1.226.172 2.257.744 3.094 1.716.836.973 1.254 2.117 1.254 3.433 0 1.43-.502 2.631-1.505 3.603-.948.973-2.119 1.46-3.512 1.46-1.617 0-2.955-.659-4.014-1.974-1.004-1.373-1.506-3.147-1.506-5.32zM0 13.243c0-1.545.279-3.06.836-4.548.558-1.487 1.199-2.689 1.924-3.604A17.108 17.108 0 015.1 2.517c.892-.8 1.561-1.344 2.007-1.63.446-.286.753-.486.92-.6l2.258 2.402c-.335.286-.753.715-1.255 1.287-.613.743-1.226 1.687-1.84 2.831-.78 1.316-1.114 2.489-1.003 3.518 1.227.172 2.258.744 3.094 1.716.836.973 1.255 2.117 1.255 3.433 0 1.43-.502 2.631-1.506 3.603-.947.973-2.118 1.46-3.512 1.46-1.617 0-2.955-.659-4.014-1.974C.502 17.19 0 15.416 0 13.243z","fill":"currentColor"}})])
          )
        }
      }
    